import { render } from "./ChatBotAiAssistantPropsCmp.vue?vue&type=template&id=7b4003d0"
import script from "./ChatBotAiAssistantPropsCmp.vue?vue&type=script&lang=js"
export * from "./ChatBotAiAssistantPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__